import * as React  from "react";
import { useState } from "react";
import axios from "axios";

const Index = (props) => {
  const [companyGroups, setCompanyGroups] = useState(props.m_company_groups);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteCompanyGroup, setDeleteCompanyGroup] = useState({id: 0, name: ""});

  const deleteGroup = () => {
    setSuccessMessage("");
    setErrorMessage("");
    axios.delete(
      '/api/internal/company_groups/destroy', {
          data: { id: deleteCompanyGroup.id }
      })
      .then(function (response) {
        setCompanyGroups(
          companyGroups.filter(function(company_group){
              return company_group.id !== deleteCompanyGroup.id
          })
        );
        setDeleteCompanyGroup({id: 0, name: ""});
        setSuccessMessage(response.data.message);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
      });
    window.scrollTo({left: 0, top: 0, behavior: "smooth"});
  }

  return (
    <>
      {successMessage && 
      <div className="alert alert-success alert-dismissible" role="alert">
        <button 
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="閉じる">
          <span aria-hidden="true">×</span>
        </button>{successMessage}
      </div>}
      {errorMessage && 
      <div className="alert alert-danger alert-dismissible" role="alert">
        <button 
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="閉じる">
          <span aria-hidden="true">×</span>
        </button>{errorMessage}
      </div>}
      <div className="container mt50">
        <h3>企業グループ一覧</h3>
        <div className="row">
          <div className="col-sm-10"></div>
          <div className="col-sm-2">
            <button className="mb20 btn btn-primary" disabled={props.is_reader} onClick={()=> location.href = ("/company_group/new")}>企業グループ作成</button>
          </div>
        </div>
        <table id="notice_table" className="table table-bordered table-hover pointer mt30">
          <thead>
            <tr className="success">
              <th scope="col" className="text-center col-lg-1 col-md-1 col-sm-1 col-xs-1">
                グループID
              </th>
              <th scope="col" className="text-center col-lg-1 col-md-1 col-sm-1 col-xs-1">
                グループ名
              </th>
              <th scope="col" className="text-center col-lg-3 col-md-3 col-sm-3 col-xs-3" colSpan={2}></th>
            </tr>
          </thead>
          <tbody>
            {companyGroups.map((group, i) => {
              return (
                <tr key={i}>
                  <td className="text-center col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    {group.group_id}
                  </td>
                  <td className="text-center col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    {group.name}
                  </td>
                  <td className="text-center">
                    <a className="btn btn-primary" href={`/company_group/${group.id}/edit`}>編集</a>&emsp;&emsp;
                    <button className="btn btn-danger" data-toggle="modal" data-target="#company_group_delete_modal"　onClick={() => setDeleteCompanyGroup(group)} disabled={props.is_reader}>削除</button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        {/* ボタン類 */}
        <div>
          <div className="actions mt40">
              <a className="btn btn-primary pull-left m5" href="/company/index">戻る</a>
          </div>
        </div>
      </div>

          {/* 削除モーダル */}
      <div className="modal fade" data-backdrop="static" id="company_group_delete_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>削除します</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
          以下の企業グループを削除します。<br />
          よろしいですか？<br />
          【{deleteCompanyGroup && deleteCompanyGroup.name}】<br/>
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: 'red', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={()=>deleteGroup()}
          >
          削除する
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>
    </>
  )
}

export default Index
